import { DatePipe } from '@angular/common';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { AgentscriptService_updated } from 'src/app/services/agent-script-service/agent-script-service';
import { environment } from 'src/environments/environment';
import { UserserviceService } from 'src/app/services/userservice/userservice.service';
import { NgbDropdown } from '@ng-bootstrap/ng-bootstrap';
import { TableauReportsService } from 'src/app/services/sm-Services/tableau-reports.service';
import { ApiService } from 'src/app/services/sm-Services/api.service';
import { StandardUIService } from 'src/app/services/standardui-service/standardui-service';

@Component({
  selector: 'app-smartreports',
  templateUrl: './smartreports.component.html',
  styleUrls: ['./smartreports.component.scss']
})
export class SmartreportsComponent {
  @Output() componentSelection = new EventEmitter<any>();
  @ViewChild('filterDropdown') filterDropdown: any;
  favreports:any;
  isOpen: boolean = false;
  site_name: any
  site_id: any
  auth_token

  // logintableauadmin() {
  //   this.Tableauservice.login().subscribe(data => {
  //     console.log(data)
  //     if (data.credentials.site.contentUrl == "") {
  //       this.site_name = "Default"
  //     }
  //     else {
  //       this.site_name = data.credentials.site.contentUrl;
  //     }
  //     this.site_id = data.credentials.site.id;
  //     this.auth_token = data.credentials.token;
  //     this.agentscriptservice.tableau_site_id = data.credentials.site.id;
  //     this.agentscriptservice.tableau_auth_token = data.credentials.token;

  //   })
  // }


  searchterms: any = '';
  departmentDataSource: any;
  input: any;
  tcontainer = {
    height: (($(window).height() - $('.layout-navbar').height()) - 300) + 'px'
  };

  searchTerm: string = '';
  objListVal: any = [];
  departmentItems: any = [];
  pageSize: any = 5;
  pageSizeOptions: any = [10, 15, 20, 25];

  constructor(private stnadardUiService:StandardUIService,private userservice:UserserviceService, private Tableauservice: TableauReportsService, private agentscriptservice: AgentscriptService_updated, private http: HttpClient, private apiservice: ApiService) {
  }

  selectAllStars: boolean = false;
  toggleAllStars() {
    for (let item of this.displayarray) {
      item.myfavourite = this.selectAllStars;
    }
  }
  // toggleDropdown() {
  //   this.isOpen = !this.isOpen;
  // }
  togglefavourites(data: any) {
    console.log(data)
    data.myfavourite = !data.myfavourite;

  }
  favcheck(cwid: any) {
    return this.favreports?.findIndex(({ id }) => id == cwid);
  }
  favupdate(wbid: any, bool: any) {
    console.log(wbid);
    console.log(bool);

    const requestBody = {
        workbookid: wbid,
        type: 'fav',
        bool: bool
    };

    this.http.put(environment.smartReportURL + "updatefavrcvwtl", requestBody).subscribe((data) => {
        console.log(data);
        console.log(this.displayarray);

        if (bool) {
            // If bool is true, increment getfav()
            this.getfav();
        } else {
          console.log("hyy")
            // If bool is false, delete the record from getfav()
            this.displayarray = this.displayarray.filter(item => item.id !== wbid);
            this.getfav();
            this.datatableload=false
            setTimeout(() => {
            this.datatablepagination()
            }, 100);
            // setTimeout(() => {
            //   this.datatablepagination();
            // }, 100);


            // this.datatablepagination();
            // Optionally, trigger any additional actions after deletion
        }
    });
}

  selectAllCheckboxes: boolean = false;

  toggleAllCheckboxes() {
    for (let item of this.displayarray) {
      item.selectedcheckbox = this.selectAllCheckboxes;
    }
  }
  togglecheckbox(data: any) {
    console.log(data)
    data.selectedcheckbox = !data.selectedcheckbox;
  }
  // downloadreport(item: any) {
  //   console.log("download report of")
  //   console.log(item)
  //   this.Tableauservice.download_report(item.workbookid, item.workbookname, item.defaultviewid, '')
  // }
  // reportcount=1;
  openreport(item: any) {
    console.log("open report of")
    console.log(item)
    item.auth_token = this.Tableauservice.auth_token
    item.site_id = this.Tableauservice.site_id
    console.log(item)

    const requestBody = {
      workbookid: item.id,
      bool:true,
      type: 'rcv'
  };

    this.http.put(environment.smartReportURL + "updatefavrcvwtl", requestBody).subscribe((data) => {
      console.log(data);
      // console.log(this.displayarray);

  });


    // {id: 'Smartreports', name: 'Smart Reports' , type:'Smartreports'}
    // {"reportname": "report1","path": "folder1", "details": "details" }
    this.componentSelection.emit({ id: 'tableaureport' + item.workbookname, name: item.workbookname, type: 'tableaureport',src:'../../assets/images/smartreporter.svg', Objectdata: item })
    // this.reportcount++;

  }
  myfavlist()
  {

  }
  clearsearch() {
    this.searchterms = ""

    $('.pane:visible .dt-search input').val("").keyup();

  }
filtercategorynames:any=['General Reports','Solid Waste','Information Ticket','SLA Report','Filtration']
selectedCategories: any[] = [];
filteredData:any;
dropdownOpen: boolean = false;
autoClose: NgbDropdown['autoClose'] = false;
showClearButton: boolean = false;
@ViewChild(NgbDropdown) dropdown: NgbDropdown;
originalDisplayArray: any[]; // Define a property to hold the original array

// Assuming displayArray is already initialized


isSelected(category: string): boolean {
  // this.searchPerformed=false;
  // console.log(category)
   return this.selectedCategories.includes(category);
}
checkcategories:any=[]
selectCategory(category: string) {
  console.log(category)
  const index = this.checkcategories.indexOf(category);

  console.log(index)
  if (index === -1) {
// If category not in selectedCategories, add it
// console.log(this.displayarray)

this.checkcategories.push(category)
    // this.selectedCategories.push(category);


    console.log(this.selectedCategories)
  } else {
    // this.searchPerformed=false;
    // If category already in selectedCategories, remove it
    this.checkcategories.splice(index, 1);
    this.selectedCategories.splice(index, 1)
  }
}

  closeDropdownMenu() {
    // Close the dropdown menu using JavaScript or any library-specific method
    // For example, if you are using NgbDropdown, you can close it like this:
    document.querySelector('.query-filters').classList.remove('show');
  }
  toggleDropdown() {
    this.dropdownOpen = !this.dropdownOpen;
    if (!this.dropdownOpen) {
      this.filterDropdown.close();
    }
  }
  clear() {
    // Clear selected categories
    // if (this.dropdown) {
    //   this.dropdown.close(); // Close the dropdown if it exists
    // }
    this.showClearButton=false;
    this.selectedCategories = [];
    this.fromDate='';
    this.toDate='';
  }
  ngOnChanges()
  {
    this.searchPerformed=false;
  }
  searchPerformed:boolean=false;
  search() {
    this.selectedCategories=[]
    this.selectedCategories= [...this.checkcategories];
    console.log("hyy")
    console.log(this.filtername)
    this.showClearButton = true;
    this.searchPerformed = true;

    // Perform search operation with selected categories
    console.log('Selected Categories:', this.selectedCategories);
    console.log('Selected Date Range:', this.fromDate, '-', this.toDate);
    const originalData = [...this.displayarray]
   console.log(originalData)
    console.log(this.displayarray)
    console.log(this.newcaseTypeVal)
    if (this.filtername === undefined) {
      let filteredData = [...this.newcaseTypeVal];

      // Filter based on categories if selected
      if (this.selectedCategories.length > 0) {
          filteredData = filteredData.filter(item => {
              const categories = item.path.split('>').map(c => c.trim());
              return categories.some(c => this.selectedCategories.includes(c));
          });
      }

      // Filter based on date range if both fromDate and toDate are provided
      if (this.fromDate && this.toDate) {
          const fromDate = new Date(this.fromDate);
          const toDate = new Date(this.toDate);
          filteredData = filteredData.filter(item => {
              const createdDate = new Date(item.createdon);
              return createdDate >= fromDate && createdDate <= toDate;
          });
      }

      this.filteredData = filteredData;
  } else if (this.filtername === "My Favourites") {
      let filteredData = [...this.myfavourites];
console.log(filteredData)
      // Filter based on categories if selected
      if (this.selectedCategories.length > 0) {
          filteredData = filteredData.filter(item => {
              const categories = item.path.split('>').map(c => c.trim());
              return categories.some(c => this.selectedCategories.includes(c));
          });
      }

      // Filter based on date range if both fromDate and toDate are provided
      if (this.fromDate && this.toDate) {
          const fromDate = new Date(this.fromDate);
          const toDate = new Date(this.toDate);
          filteredData = filteredData.filter(item => {
              const createdDate = new Date(item.createdon);
              return createdDate >= fromDate && createdDate <= toDate;
          });
      }

      this.filteredData = filteredData;
  } else if (this.filtername === "Recently Viewed") {
      let filteredData = [...this.recentlyviewed];
console.log(filteredData)
      // Filter based on categories if selected
      if (this.selectedCategories.length > 0) {
          filteredData = filteredData.filter(item => {
              const categories = item.path.split('>').map(c => c.trim());
              return categories.some(c => this.selectedCategories.includes(c));
          });
      }

      // Filter based on date range if both fromDate and toDate are provided
      if (this.fromDate && this.toDate) {
          const fromDate = new Date(this.fromDate);
          const toDate = new Date(this.toDate);
          filteredData = filteredData.filter(item => {
              const createdDate = new Date(item.createdon);
              return createdDate >= fromDate && createdDate <= toDate;
          });
      }

      this.filteredData = filteredData;
  }
    console.log(this.filteredData)
  this.displayarray=this.filteredData;
  console.log(this.displayarray)
  if (this.dropdown) {
    this.dropdown.close(); // Close the dropdown if it exists
  }
    // Output the filtered data
    this.datatableload=false
    setTimeout(() => {
    this.datatablepagination()
    }, 100);
    $("[data-filter-id='" + this.filtername + "']").attr('data-filter-close', 'close')

    $("[data-filter-id]").not("[data-filter-id='" + this.filtername + "']").attr('data-filter-close', 'open');
    // Add your search logic here
  }
  filterboxes: any = [
    {
      'name': 'My Favourites',
      'image': '../../assets/images/favourites.svg'
    },
    {
      'name': 'Recently Viewed',
      'image': '../../assets/images/recent.svg'
    },
  ];
  newcaseTypeVal: any;
  fromDate: string; // Property to store selected from date
  toDate: string;
  tableId: any
  tab_title: any
  displayarray: any
  path: any
  // reportname path details
  displayingdatainarray(array: any, path: string = '') {
    for (var i = 0; i < array.length; i++) {
      const currentCategory = array[i].categoryname;
      const currentPath = path === '' ? currentCategory : path + '>' + currentCategory;

      if (array[i].hasOwnProperty('subgroups')) {
        this.displayingdatainarray(array[i].subgroups, currentPath);
      }

      if (array[i].hasOwnProperty('wbs')) {
        console.log("it has reports");
        console.log(array[i]);

        for (var j = 0; j < array[i].wbs.length; j++) {
          this.displayarray.push({
            // reportname: array[i].wbs[j].workbookname,
            // path: currentPath,
            // date_created: array[i].wbs[j].createdon,
            // projectName:array[i].wbs[j].projectname,
            // workbookid:array[i].wbs[j].workbookid,
            id: array[i].wbs[j].id,
            path: currentPath,
            reportid:array[i].wbs[j].reportid,
            workbookid: array[i].wbs[j].workbookid,
            workbookname: array[i].wbs[j].workbookname,
            projectid: array[i].wbs[j].projectid,
            projectname: array[i].wbs[j].projectname,
            siteid: array[i].wbs[j].siteid,
            sitename: array[i].wbs[j].sitename,
            defaultviewid: array[i].wbs[j].defaultviewid,
            contenturl: array[i].wbs[j].contenturl,
            viewurlname: array[i].wbs[j].viewurlname,
            createdon: array[i].wbs[j].createdon,
            updatedon: array[i].wbs[j].updatedon,
            active: array[i].wbs[j].active,
            deletedon: array[i].wbs[j].deletedon,
            querybuilder: array[i].wbs[j].querybuilder,
            lastviewed: array[i].wbs[j].lastviewed,
            dashboard: array[i].wbs[j].dashboard
          });
        }
      }
    }

    console.log(this.displayarray);
    this.newcaseTypeVal = this.displayarray
  }




  smartreporterURL = environment.smartReportURL;
  onDropdownOpen()
  {  this.datatableload = false
    console.log(this.newcaseTypeVal)
    // console.log(data)
    this.searchPerformed=false;
    this.showClearButton=false;
    // this.selectedCategories = [];
    this.searchPerformed=false;
    this.fromDate='';
    this.toDate='';
    // $("[data-filter-id='" + data + "']").attr('data-filter-close', 'open')
    if(this.filtername==undefined)
      {
        console.log("in filtername",this.filtername)
        this.displayarray = this.newcaseTypeVal;
        setTimeout(() => {
           this.datatablepagination();
           }, 100);
      }
      else{
        this.filter(this.filtername)
      }

  }
  showdatafilters:boolean
  ngOnInit() {
    var filtereddepartment='false'
    this.showdatafilters=true
    // this.logintableauadmin();


    this.tab_title = $(".custom-tabs li.active").find("a").attr('data-obj-title')
    this.tableId = $(".custom-tabs li.active").find("a").attr('data-obj-title') + "-listviewtable"
    console.log("tableIdtableIdtableIdtableId", this.tableId)
    // this.http.get<any>('/assets/json/Smartreporterjson.json').subscribe((data) => {
    // this.http.get<any>('/assets/json/smartreporter_backend.json').subscribe((data) => {
    this.http.get<any>(environment.smartReportURL + 'getcategoriesByUserAndRole/' + this.userservice.user_roleid).subscribe((data) => {
      console.log(data)
      console.log(this.displayarray)
      this.displayarray = []
      this.displayingdatainarray(data, '')
      this.datatablepagination()

      this.stnadardUiService.castuserDetails.subscribe((data)=>{
        if(data){
          console.log(data);
          // console.log(data.roles[0].authority)
          if(data.roles && data.roles[0]?.authority)
          {
            filtereddepartment=data.roles[0]?.authority.replace(/[^a-zA-Z0-9]/g, '').toLowerCase()
            if(filtereddepartment.includes('solidwaste'))
            {
              this.showdatafilters=false
            }
          }
        }
      })
    });
this.getfav();
    // this.http.get<any>('/assets/json/filter_tags.json').subscribe((data) => {
    //   this.filterboxes = data[0].filter;

    // });

  }

getfav()
{
 return this.http.get<any>(environment.smartReportURL + 'getfav').subscribe((data) => {
    console.log(data)
    this.favreports=data;
    // this.displayarray = []
    // this.displayingdatainarray(data, '')
    // this.datatablepagination()
  });
}
datatablemyfav()
{
  setTimeout(() => {
    ($('#myfav') as any).dataTable({
      "language": {
        "paginate": {
          "previous": "",
          "next": ""
        },
        "lengthMenu": "Records per page _MENU_",
      },
      pageLength: 10,
      "order": [[2, "asc"]],

      "columnDefs": [
        { "orderable": false, "targets": 0 },
        { "orderable": false, "targets": 1 },
        { 'orderable': false, 'targets': 5 }
      ],

      "lengthMenu": [[10, 25, 50, -1], [10, 25, 50, "All"]],
      //   fixedColumns: {
      //     start: 1,
      //     end: 1
      // },
      paging: true,
      fixedHeader: true,
      // scrollX: false,
      scrollY: this.tcontainer.height,
      destroy: true,
      dom: 'frtlip',

      drawCallback: function (settings) {
        const api = this.api();
        const rows = api.rows({ page: 'current' }).nodes();
        let startIndex = api.page() * api.page.len() + 1;

        $(rows).each(function (index) {
          $('td', this).eq(0).html(startIndex.toString()); // Convert to string before setting as HTML content
          startIndex++;
        });
      },
    });
  }, 200);

  this.datatableload = true
}
  datatablepagination() {
    // ($('#smartreportstable') as any).DataTable().destroy();

    $("#smartreportstable_wrapper").remove();

    setTimeout(() => {
      ($('#smartreportstable') as any).dataTable({
        "language": {
          "paginate": {
            "previous": "",
            "next": ""
          },
          "lengthMenu": "Records per page _MENU_",
        },
        pageLength: 10,
        "order": [[3, "asc"]],

        "columnDefs": [
          { "orderable": false, "targets": 0 },
          { "orderable": false, "targets": 1 },
          { 'orderable': false, 'targets': 6 }
        ],

        "lengthMenu": [[10, 25, 50, -1], [10, 25, 50, "All"]],
        //   fixedColumns: {
        //     start: 1,
        //     end: 1
        // },
        paging: true,
        fixedHeader: true,
        // scrollX: false,
        scrollY: this.tcontainer.height,
        destroy: true,
        dom: 'frtlip',

        drawCallback: function (settings) {
          const api = this.api();
          const rows = api.rows({ page: 'current' }).nodes();
          let startIndex = api.page() * api.page.len() + 1;

          $(rows).each(function (index) {
            $('td', this).eq(0).html(startIndex.toString()); // Convert to string before setting as HTML content
            startIndex++;
          });
        },
      });
    }, 200);

    this.datatableload = true
  }
  datatableload: boolean
  pagination() {
    $('body').addClass('pagination');
  }
  closefilter(data: any) {
    
    this.selectedCategories=[]
    this.checkcategories=[]
    
    this.datatableload = false
    console.log(this.newcaseTypeVal)
    console.log(data)
    this.showClearButton=false;
    this.selectedCategories = [];
    $("[data-filter-id='" + data + "']").attr('data-filter-close', 'open')
    this.displayarray = this.newcaseTypeVal;
    this.filtername=undefined;

    setTimeout(() => {
      this.datatablepagination();
    }, 100);
  }
  closeselectedfilter(category: any) {
    this.showClearButton=false;
    // this.selectedCategories = [];
    // this.fromDate='';
    // this.toDate='';
    console.log(this.filtername)
    // Remove the category from the selectedCategories array
    const index = this.selectedCategories.indexOf(category);
    if (index !== -1) {
      this.selectedCategories.splice(index, 1);
      this.checkcategories.splice(index, 1);
    }

    // Filter out items with the selected category from displayarray
    if((this.displayarray.length!=0))
      {
        console.log("in filter")

        this.displayarray = this.displayarray.filter(item => {
          return item.path.indexOf(category) === -1;

        });
        if(this.filtername===undefined|| this.selectedCategories.length>=1)
          {
            this.datatableload=false
            setTimeout(() => {
               this.datatablepagination();
               }, 100);
          }

      }

console.log(this.displayarray.length)

    if(this.filtername==undefined&&this.displayarray.length === 0)
      {
        console.log("in filtername",this.filtername)
        this.displayarray = this.newcaseTypeVal;

        this.datatableload=false
        setTimeout(() => {
           this.datatablepagination();
           }, 100);
      }
      else if(this.filtername!=undefined&&this.displayarray.length === 0){
        this.filter(this.filtername)

      }
// this.datatableload=false
    // setTimeout(() => {
    // this.datatablepagination()
    // }, 100);
    // console.log(this.displayarray);



  }

  closefilters(data: any) {
    this.datatableload = false
    console.log(this.newcaseTypeVal)
    console.log(data)
    this.showClearButton=false;
    this.selectedCategories = [];
    this.fromDate='';
    this.toDate='';
    $("[data-filter-id='" + data + "']").attr('data-filter-close', 'open')
    if(this.filtername==undefined)
      {
        console.log("in filtername",this.filtername)
        this.displayarray = this.newcaseTypeVal;
        setTimeout(() => {
           this.datatablepagination();
           }, 100);
      }
      else{
        this.filter(this.filtername)
      }
    // this.displayarray = this.newcaseTypeVal;

    // setTimeout(() => {
    //   this.datatablepagination();
    // }, 100);
  }

  displayclose(item: any) {
    return $("[data-filter-id='" + item + "']").attr('data-filter-close')
  }

filtername:any;
myfavourites:any;
recentlyviewed:any;
  filter(data: any) {
    this.selectedCategories=[]
    this.checkcategories=[]
    console.log(data)
    this.showClearButton = false;
    this.selectedCategories=[];
    this.displayarray=this.newcaseTypeVal;
    this.filtername=data;
    if(data.includes('Favourites'))
      {
        this.datatableload = false
        this.http.get<any>(environment.smartReportURL + 'getfav').subscribe((data) => {
          console.log(data)
          var favdata: any = []
          favdata=data
          var filterringarray;
          filterringarray=this.displayarray.filter(item1=>
            favdata.some(item2 => item1.workbookid == item2.workbookid && item1.contenturl == item2.contenturl)
          )
        this.myfavourites=filterringarray;
        this.displayarray=filterringarray
        setTimeout(() => {
          this.datatablepagination();
        }, 100);

        });
      }
      else if(data.includes('Recently'))
      {
        this.datatableload = false
        this.http.get<any>(environment.smartReportURL + 'getrcv').subscribe((data) => {
          console.log(data)
          console.log(this.displayarray)
          // this.displayarray=data;
          var recentdata: any = []
          recentdata=data
          var filterringarray;
          filterringarray=this.displayarray.filter(item1=>
            recentdata.some(item2 => item1.workbookid == item2.workbookid && item1.contenturl == item2.contenturl)
          )
this.recentlyviewed=filterringarray;
        this.displayarray=filterringarray
        setTimeout(() => {
          this.datatablepagination();
        }, 100);

        });
      }

    $("[data-filter-id='" + data + "']").attr('data-filter-close', 'close')

    $("[data-filter-id]").not("[data-filter-id='" + data + "']").attr('data-filter-close', 'open');

    // this.displayarray = [...this.newcaseTypeVal].filter((x: any) => x.filteringvalues && x.filteringvalues.includes(data))


  }

  onSelect(item: any) {
    this.searchterms = item.content
    $('.pane:visible .dt-search input').val(this.searchterms).keyup();

  }

  applyFilter(event: Event) {

    // this.searchterms = this.searchterms.toLowerCase();
    $('.pane:visible .dt-search input').val(this.searchterms).keyup();


  }
  onEnter(event: any) {
    const filterValue = (event.option.value && event.option.value.name || '').toString().toLowerCase();
  }

}
